// tslint:disable
/**
 * Ux
 * insightux admin api
 *
 * The version of the OpenAPI document: 0.62
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function UserDefinedMarketDataFromJSON(json) {
    return {
        'vintages': !exists(json, 'vintages') ? undefined : json['vintages'],
        'strategies': !exists(json, 'strategies') ? undefined : json['strategies'],
        'geographies': !exists(json, 'geographies') ? undefined : json['geographies'],
        'currencies': !exists(json, 'currencies') ? undefined : json['currencies'],
        'assetClasses': !exists(json, 'assetClasses') ? undefined : json['assetClasses'],
    };
}
export function UserDefinedMarketDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'vintages': value.vintages,
        'strategies': value.strategies,
        'geographies': value.geographies,
        'currencies': value.currencies,
        'assetClasses': value.assetClasses,
    };
}
